module.exports = __webpack_public_path__ + "img/1f01fe7148da99fd986cbf339a02b8e3.png";